// extracted by mini-css-extract-plugin
export default {"videoCard":"VideoCard_videoCard__+04Jb","videoCardActionInfo":"VideoCard_videoCardActionInfo__nkyYt"};